import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface AIChatPinState {
  isPinned: boolean;
  isOpen: boolean;
  isPoppedOut: boolean;
  togglePin: () => void;
  toggleOpen: () => void;
  setOpen: (open: boolean) => void;
  setPinned: (pinned: boolean) => void;
  setPoppedOut: (popped: boolean) => void;
}

export const useAIChatPinStore = create<AIChatPinState>()(
  persist(
    (set) => ({
      isPinned: false,
      isOpen: false,
      isPoppedOut: false,

      togglePin: () => {
        set((state) => ({ isPinned: !state.isPinned }));
      },

      toggleOpen: () => {
        set((state) => ({ isOpen: !state.isOpen }));
      },

      setOpen: (open: boolean) => {
        set({ isOpen: open });
      },

      setPinned: (pinned: boolean) => {
        set({ isPinned: pinned });
      },

      setPoppedOut: (popped: boolean) => {
        set({ isPoppedOut: popped });
      },
    }),
    {
      name: "ai-chat-pin-storage", // content of the caching mechanism
      partialize: (state) => ({ isPinned: state.isPinned, isOpen: state.isOpen }), // persist isPinned and isOpen
    }
  )
);
